// extracted by mini-css-extract-plugin
module.exports = {"container":"PlaylistRedirect_container__1OOag","background":"PlaylistRedirect_background__2xIVS","typography":"PlaylistRedirect_typography__3-pgY"};